// extracted by css-extract-rspack-plugin
export default {"form":"form-MvL5ou","tips":"tips-KciUcb","padd":"padd-FH54gd"};